import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useRef, useState } from 'react';
export var useIsOpen = function useIsOpen(autoOpen) {
  var timer = useRef();
  var clearTimer = useCallback(function () {
    if (timer.current) clearTimeout(timer.current);
  }, []);
  useEffect(function () {
    return function () {
      return clearTimer();
    };
  }, []);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var setDelayedIsOpen = useCallback(function (val) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    if (timer.current) clearTimer();
    timer.current = setTimeout(function () {
      return setIsOpen(val);
    }, timeout);
  }, []);
  useEffect(function () {
    if (autoOpen) setIsOpen(autoOpen);
  }, [autoOpen]);
  return [isOpen, setIsOpen, setDelayedIsOpen, clearTimer];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/useIsOpen.js
// module id = 5610
// module chunks = 11